// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__qpbme","row":"style_row__omPtY","CTA":"style_CTA__EePZ4"};